import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { RECIPIENT_TYPE_LIST_SHOWN, RECIPIENT_TYPE_SELECTED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { RECIPIENT_TYPE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { BUSINESS, INDIVIDUAL, SELF } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { RECIPIENT_TYPE_BUSINESS, RECIPIENT_TYPE_OTHER, RECIPIENT_TYPE_SELF } from 'apps/auth/constants/Constants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const ChooseWhoToSendPopup = (props) => {
    const { popupBeforeSendTitle, popupBeforeSendButtonMyself, popupBeforeSendButtonSomeoneElse, popupBeforeSendButtonOrganisation } = usePageMessages();
    const { hideToBusinessRecipient: hideToBusinessRecipientFromExtra } = useExtra();
    const hideToBusinessRecipient = props.hideToBusinessRecipient ?? hideToBusinessRecipientFromExtra;

    useEffect(() => {
        amplitude.getInstance().logEvent(RECIPIENT_TYPE_LIST_SHOWN);
    }, []);

    const handleClick = (recipientType) => {
        amplitude.getInstance().logEvent(RECIPIENT_TYPE_SELECTED, { [RECIPIENT_TYPE]: recipientType });
        props.toggleSpinner(true);
        props.popupRef?.current?.close();
    };
    return (
        <SimplePopup text={popupBeforeSendTitle} popupRef={props.popupRef}>
            <PopupButton
                href={props.uri + `?type=${RECIPIENT_TYPE_SELF}&hideRecipientList=true`}
                iconName="person"
                text={popupBeforeSendButtonMyself}
                onClick={() => handleClick(SELF)}
                hasDiskBadgeIcon
                dataTestId="recipient-type-self"
            />
            <PopupButton
                href={props.uri + `?type=${RECIPIENT_TYPE_OTHER}&hideRecipientList=true`}
                iconName="people"
                text={popupBeforeSendButtonSomeoneElse}
                onClick={() => handleClick(INDIVIDUAL)}
                hasDiskBadgeIcon
                dataTestId="recipient-type-other"
            />
            {!hideToBusinessRecipient && (
                <PopupButton
                    href={props.uri + `?type=${RECIPIENT_TYPE_BUSINESS}&hideRecipientList=true`}
                    iconName="briefcase"
                    text={popupBeforeSendButtonOrganisation}
                    onClick={() => handleClick(BUSINESS)}
                    hasDiskBadgeIcon
                    dataTestId="recipient-type-business"
                />
            )}
        </SimplePopup>
    );
};
export default connect(null, { toggleSpinner })(ChooseWhoToSendPopup);
